var map = {
	"./arrow-up.svg": 2141,
	"./ls2025bg-mobile.png": 6339,
	"./ls2025bg.png": 6174,
	"./ls2026bg-mobile.png": 7642,
	"./ls2026bg.png": 3633,
	"./menu.svg": 5523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6608;